export default Object.freeze({
  initial: 'initial',
  clockedIn: 'clockedIn',
  onMealBreak: 'onMealBreak',
})
